<template>
  <!-- Main Content -->
  <div id="content">
    <!-- Begin Page Content -->
    <div class="container-fluid">
      <!-- Page Heading -->
      <h1 class="h3 mb-2 text-gray-800">Subcategorías</h1>
      <!-- DataTales Example -->
      <div class="card shadow mb-4">
        <div class="row">
          <div class="col-md-6">
            <div>
              <form
                class="d-none d-sm-inline-block form-inline mr-auto ml-md-4 my-2 my-md-0 mw-100 navbar-search">
                <div class="input-group">
                  <input type="text" class="form-control bg-light border-0 small" placeholder="Buscar Categoría"
                         aria-label="Search" aria-describedby="basic-addon2" v-model="search">
                  <div class="input-group-append">
                    <button class="btn btn-primary" type="button" @click="loadSubcategory">
                      <font-awesome-icon icon="search" />
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
          <div class="col-md-6">

            <div class="text-right" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">
              <router-link to="/admin-panel/Subcategories/create">
                <b-button variant="primary">
                  <font-awesome-icon icon="fas fa-plus-square" />&nbsp;Crear Subcategoría
                </b-button>
              </router-link>
            </div>

          </div>
        </div>
        <div class="card-body">
          <div class="table-responsive">
            <b-table striped hover :items="categoriesItems" :fields="fields">

              <template #cell(deleted)="data">
                <span v-if="data.item.deleted">Sí</span>
                <span v-else>No</span>
              </template>

              <template #cell(category)="data">
                <span v-if="data.item.category">{{data.item.category.description}}</span>
              </template>

              <!-- A virtual column -->
              <template #cell(actions)="data" v-if="userPermission !== 'ROLE_STUDENT' && userPermission !== 'ROLE_SUPERVISOR'">
                <b-dropdown id="dropdown-1" text="Acciones" class="m-md-1">
                  <b-dropdown-item><router-link :to="{ name: 'SubcategoriesEdit', params: { id: data.item.id}}" >
                    <font-awesome-icon icon="fas fa-edit" />&nbsp;Editar
                  </router-link></b-dropdown-item>

                  <b-dropdown-item  v-if="!data.item.deleted || data.item.deleted == false" @click="deleteSubcategory(data.item.id)">
                    <a href="#"><font-awesome-icon icon="fas fa-trash" />&nbsp;Eliminar</a>
                  </b-dropdown-item>
                  <b-dropdown-item  v-if="data.item.deleted == true" @click="deleteSubcategory(data.item.id)">
                    <a href="#"><font-awesome-icon icon="fas fa-check-to-slot" />&nbsp;Activar</a>
                  </b-dropdown-item>
                </b-dropdown>
              </template>
            </b-table>

            <b-pagination
              v-model="currentPage"
              :total-rows="rows"
              :per-page="perPage"
              aria-controls="my-table"

            ></b-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- /.container-fluid -->

  </div>
  <!-- End of Main Content -->
</template>

<script>
import axios from "axios";

export default {
  name: "SubcategoryAdmin",
  data: () => {
    return {
      fields: [
        {
          key: 'description',
          sortable: true,
          label: "Subcategoría",
          class: 'w-25'
        },
        {
          key: 'category',
          sortable: true,
          label: "Categoría",
          class: 'w-25'
        },
        {
          key: 'deleted',
          label: 'Eliminado',
          sortable: false,
          class: 'w-25'
        },
        {
          key: 'actions',
          label: '',
          sortable: true,
          class: 'w-25'
        }
      ],
      search: '',
      categoriesItems: [],
      currentPage: 1,
      rows: 10,
      perPage: 10,
      userPermission: ''
    }
  },
  methods: {
    deleteSubcategory(id) {
      if(!confirm("¿Estás seguro que deseas eliminar esta subcategoría?")){
      return
    }
      let loader = this.$loading.show({});
      axios.delete(
        import.meta.env.VITE_API_BASE_URL + "/api/subcategory/" + id,
        {
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then(() => {
        this.loadSubcategory()
        loader.hide();
      })
      .catch((err) => {
        console.log(err.message);
        loader.hide();
      });
    },
    loadSubcategory () {
      let loader = this.$loading.show({});
      axios.get(
        import.meta.env.VITE_API_BASE_URL + "/api/subcategory/list",
        {
          params: { page: this.currentPage, size: this.perPage, sort: 'DESC', search:  this.search },
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
          },
        }
      )
      .then((response) => {
        loader.hide();
        this.categoriesItems = response.data;
        this.rows = response.data.totalElements
      })
      .catch((err) => {
        console.log(err.message);
        loader.hide();
      });
    }
  },
  watch: {
    currentPage: function () {
      this.loadSubcategory()
    }
  },
  mounted() {
    this.loadSubcategory();
    this.userPermission =  localStorage.getItem("role")
  },
  beforeMount() {
    (function () {
      var script = document.createElement("script");
      script.type = "text/javascript";
      script.src =
        "https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-AMS_HTML";
      document.getElementsByTagName("head")[0].appendChild(script);
    })();
  },
};
</script>

<style scoped>

</style>
